document.addEventListener('DOMContentLoaded', function () {

  // ── SCROLL REVEAL ──
  try {
    var reveals = document.querySelectorAll('.reveal');
    if (reveals.length > 0) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });

      reveals.forEach(function (el) {
        if (el) revealObserver.observe(el);
      });

      reveals.forEach(function (el) {
        if (el) {
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight) el.classList.add('visible');
        }
      });
    }
  } catch(e) {
    console.log('Reveal error:', e);
  }

  // ── PRODUCT CAROUSEL ──
  // Handled per-section in featured-products.liquid (responsive, snap-based).

  // ── CART COUNT ──
  try {
    function updateCartCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var counts = document.querySelectorAll('.cart-count');
          counts.forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }
    document.addEventListener('cart:updated', updateCartCount);
  } catch(e) {}

  // ── CLOSE SEARCH ON ESCAPE ──
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var overlay = document.querySelector('.search-overlay');
      if (overlay) overlay.classList.remove('active');
    }
  });

});